import { composeIO } from 'react-compose-io'
import { lancamentoAssociacaoIO } from './LancamentoAssociacao.IO'
import { LancamentoAssociacaoView } from './LancamentoAssociacao.View'

export const LancamentoAssociacao = composeIO(LancamentoAssociacaoView, lancamentoAssociacaoIO)
